import { GlobalStore, PaymentMethod } from '@/types/stores/global';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useGlobalStore = create<GlobalStore>()(
  persist(
    (set, get) => ({
      orderId: null,
      paymentId: null,
      paymentMethod: PaymentMethod.Swish,

      browse: () => set({ paymentId: null, orderId: null, paymentMethod: PaymentMethod.Swish }),
      checkout: (orderId: string) => set({ orderId }),
      pay: (paymentId: string) => set({ paymentId }),
      stopPayment: () => set({ paymentId: null }),
      restore: (orderId, paymentId) => {
        set({ orderId, paymentId });
      },
      reset: () => {
        set({
          orderId: null,
          paymentId: null,
          paymentMethod: PaymentMethod.Swish,
        });
      },

      setPaymentMethod: (paymentMethod) => set({ paymentMethod }),
    }),
    {
      name: 'global-store',
      partialize: (state) => ({
        orderId: state.orderId,
        paymentId: state.paymentId,
      }),
    },
  ),
);

export default useGlobalStore;
